import {Component, OnInit, ViewChild} from '@angular/core';
import {VnaCallerIdService} from '../../services/vna-caller-id.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {ModalService} from 'ngx-dynamic-modal';
import {VnaCallerIdEditComponent} from '../../modals/vna-caller-id-edit/vna-caller-id-edit.component';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {PaginationComponent} from '../../../../../shared/components/pagination/pagination.component';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import * as moment from 'moment';
import * as _ from 'underscore';
import {Angular2Csv} from 'angular2-csv';
import {CallerIdAssignComponent} from '../../modals/caller-id-assign/caller-id-assign.component';
import { AuthService } from 'app/core/service/auth.service';
import {CallerIdsFileUploadComponent} from '../../modals/caller-ids-file-upload/caller-ids-file-upload.component';

@Component({
  selector: 'app-vna-caller-id',
  templateUrl: './vna-caller-id.component.html',
  styleUrls: ['./vna-caller-id.component.scss']
})
export class VnaCallerIdComponent implements OnInit {

    rows: Array<Object> = [];
    temp: Array<Object> = [];
    loading: boolean = false;
    form: FormGroup;

    reportData: Object = {};

    startAt: number = 0;
    endAt: number = 0;
    perPage: number = 10;

    tableSearchText: string = '';

    @ViewChild(PaginationComponent) pagination: PaginationComponent;

    constructor(private callerIdService: VnaCallerIdService, private alertService: AlertaService, private modalService: ModalService,
      private fb: FormBuilder, private datesParser: DatesParserService, private messaging: MessagingService,
      private authService: AuthService) {
        this.form = this.fb.group({
            'start_date' : new FormControl(),
            'end_date' : new FormControl(),
            'number' : new FormControl(),
            'active' : new FormControl('1'),
            'vna_client_pks' : new FormControl(),
            'only_cids_sel_clients' : new FormControl('0')
        });
    }

    ngOnInit() {
        this.listCallerIds();
    }

    hasClientPk(): boolean {
      return this.authService.getClient() > 0;
    }

    callerIdToCampaigns(row: Object): void {
        this.modalService.addDynamicComponent(CallerIdAssignComponent, row);
    }

    getCallerIdsReport(): void {

        if(!moment.isMoment(this.form.value.start_date) || !moment.isMoment(this.form.value.end_date)){
            this.alertService.addAlert('warning', 'Select start and end date to show as report', '', -1);
            return;
        }

        this.loading = true;
        this.rows = [];
        const queryDates = this.datesParser.cleanDates(this.form.value, ['start_date', 'end_date'], true);
        this
            .callerIdService
            .getCallerIdsReport(queryDates['start_date'], queryDates['end_date'])
            .subscribe(
                (r) => {
                    this.rows = r['rows'];
                    this.endAt = (!this.haveToPaginate()) ? this.rows.length : this.perPage;
                    this.reportData['price'] = r['price'];
                    this.reportData['setup'] = r['setup'];
                    this.loading = false;
                }
            )
    }

    enableCallerId(e: any, row: Object): void {
        this.loading = true;

        const active = (e.target.checked) ? 1 : 0;
        const text = (e.target.checked) ? 'enabled' : 'disabled';

        this.alertService.addAlert('confirm','Do you want to ' + text + ' this caller id?',)
            .then((result) => {
                if (result.value) {
                    this.callerIdService.patchCallerId(row['pk'], {'active': active}).subscribe(
                        (r) => {
                            (r.status == 'KO')
                                ? this.alertService.addAlert('warning', r.error, '', -1)
                                : this.alertService.addAlert('success', 'Caller id with number ' + row['number'] + ' has been ' + text + ' successfully')
                            ;

                            this.listCallerIds();
                        })
                }

                this.loading = false;
            })
    }

    deleteCallerId(row: Object): void {
        this.loading = true;
        this.callerIdService.deleteCallerId(row['pk']).subscribe(
            (r) => {
                if(r.status == 'KO'){
                    this.alertService.addAlert('warning', r.error, '', -1);
                }
                else{
                    let i = this.rows.findIndex( (o) => { return o['pk'] == row['pk']; });
                    if(i >= 0){
                        this.rows.splice(i, 1);
                    }

                    this.alertService.addAlert('success', 'Caller Id removed successfully');
                }

                this.loading = false;
            }
        )
    }

    newCallerId(): void {
        this.modalService.addDynamicComponent(VnaCallerIdEditComponent, {'type' : 'new'}, (res) => {
            this.listCallerIds();
        });
    }

    editCallerId(row: Object): void {
        this.modalService.addDynamicComponent(VnaCallerIdEditComponent, {'object' : row, 'type' : 'edit' }, (res) => {
            this.listCallerIds();
        });
    }

    newCallerIdsFile(): void {
      this.modalService.addDynamicComponent(CallerIdsFileUploadComponent, {}, (res) => {
        this.listCallerIds();
      });
    }

    goToPage(n: number) {
        if(this.pagination){
            this.startAt = this.pagination.getStart();
            this.endAt = this.pagination.getEnd();
        }
    }

    haveToPaginate(): boolean {
        return this.perPage < this.rows.length;
    }

    reportToCsv(): void {
        let headers = {'pk': '#', 'portal' : 'Portal', 'created_at': 'Created at', 'unactived_at': 'Deactivated at', 'bought_at': 'Buy date', 'active': 'Active', 'number': 'Number', 'price' : 'Price', 'setup': 'Set up', 'source' : 'Source'};
        let hKeys = _.keys(headers);
        let hLabels= _.values(headers);

        let csvRows = this.rows.map( (o) => {
            const csvRow = {};
            hKeys.forEach( (value: string) => {
                csvRow[value] = o[value];
            } );
            return csvRow;
        });

        let resumeRow = {};
        hKeys.forEach( (value: string) => {
            (value == 'price' || value == 'setup')
                ? resumeRow[value] = this.reportData[value].toFixed(2)
                : resumeRow[value] = ''
            ;
        } );

        csvRows.push(resumeRow);

        new Angular2Csv(csvRows, 'caller_ids_report_' + moment().unix(), {
            'showLabels' : true,
            'headers' : hLabels
        });
    }

    updateFilter(event) {
        this.tableSearchText = event.target.value.toLowerCase();
        const temp = this.temp.filter((d) => {
            return d['portal'].toLowerCase().indexOf(this.tableSearchText) !== -1 || !this.tableSearchText;
        });

        this.rows = temp;
    }

    getTotalToPay(): any {
        const total = parseFloat(this.reportData['price'].toFixed(2)) + parseFloat(this.reportData['setup'].toFixed(2));
        return total.toFixed(2);
    }

    listCallerIds(): void {
        this.loading = true;
        this.rows = [];
        this.reportData = {};
        this.startAt = 0;

        const criteria = this.getCriteria();

        this.callerIdService.findCallerIds(criteria).subscribe(
            (rows: Array<Object>) => {
                this.rows = rows;
                this.temp = [...rows];
                this.endAt = (!this.haveToPaginate()) ? this.rows.length : this.perPage;
                this.loading = false;
            }
        )
    }

    sendAllToVerify(): void {
      this
        .alertService
        .addAlert('confirm', 'Caller ids will be send to verify. Are you sure?')
        .then(
          (r) => {
            if(r['value']){
              this.loading = true;

              const criteria = this.getCriteria();
              this.callerIdService.getSendCallerIdsToVerify(criteria).subscribe(
                (r: any) => {
                  this.loading = false;
                  this.alertService.addAlert('success', 'A total of ' + r.enqueued_verifications + ' have been enqueued to be verified');
                }
              )
            }
          }
        )
      ;
    }

    sendOneToVerify(row: object): void {
      this
        .alertService
        .addAlert('confirm', 'Caller id ' + row['number'] + ' will be send to verify. Are you sure?')
        .then(
          (r) => {
            if(r['value']){
              this.loading = true;
              this.callerIdService.getSendCallerIdToVerify(row['number']).subscribe(
                (r: any) => {
                  this.loading = false;
                  this.alertService.addAlert('success', 'Caller id ' + row['number'] + ' has been sent to verify');
                }
              )
            }
          }
        )
      ;
    }

    protected getCriteria(): object {
      let criteria = this.datesParser.cleanDates(Object.assign({}, this.form.value), ['start_date', 'end_date'], false);
      if(criteria.hasOwnProperty('vna_client_pks') && _.isArray(criteria['vna_client_pks'])) {
        criteria['vna_client_pks'] = criteria['vna_client_pks'].map( (clientObject: any) => {
          return clientObject['pk'];
        });
        criteria['vna_client_pks'] = criteria['vna_client_pks'].join(',');
      }
      return criteria;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/caller-id/components/vna-caller-id/vna-caller-id.component.ts